import React from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Icon } from 'semantic-ui-react';

import { NavbarContext } from '..';
import { ACCOUNT_PATH, SidebarTab } from '../../../../constants/paths/internal';
import { getClaimsDisplayedName, getDisplayedName } from '../../../../lib/user';
import { VERSION_INFO } from '../../../../version';
import DropdownMenuWrapper from '../../../common/DropdownMenuWrapper';

const VERSION_CONTENT = VERSION_INFO.tag
  ? `Version: ${VERSION_INFO.tag}`
  : VERSION_INFO.branch
  ? `${VERSION_INFO.branch} [${VERSION_INFO.commit.substring(0, 8)}]`
  : 'Local Build';

const AccountDropdownItem = () => {
  return (
    <NavbarContext.Consumer>
      {({ activeTab, logout, configurableUser, rootManaging, authenticatedUser }) => {
        const username = getDisplayedName(configurableUser!);

        const userContent = rootManaging
          ? `${getClaimsDisplayedName(authenticatedUser)} (as ${username})`
          : username;

        return (
          <Dropdown
            trigger={<UserIcon rootManaging={rootManaging} />}
            pointing="top right"
            icon={null}
            simple
            id="navbar-account-dropdown"
          >
            <DropdownMenuWrapper
              dropdownId="navbar-account-dropdown"
              position="right"
              style={{ marginTop: '0px' }}
            >
              <Dropdown.Header content={userContent} icon="user" />
              <Dropdown.Divider style={{ marginBottom: '0px' }} />
              <Dropdown.Item
                text="Settings"
                icon="settings"
                as={Link}
                to={ACCOUNT_PATH}
                active={activeTab === SidebarTab.ACCOUNT_SETTINGS}
                data-testid="settings"
              />
              <Dropdown.Item
                text="Sign out"
                icon="sign out"
                onClick={logout}
                data-testid="sign-out"
              />
              <Dropdown.Divider style={{ marginBottom: '0px' }} />
              <Dropdown.Header content={VERSION_CONTENT} icon="info circle" />
            </DropdownMenuWrapper>
          </Dropdown>
        );
      }}
    </NavbarContext.Consumer>
  );
};

const UserIcon = ({ rootManaging }: { rootManaging: boolean }) => {
  return (
    <Icon
      name={rootManaging ? 'spy' : 'user'}
      circular
      style={{ fontSize: '1.3em' }}
      color={rootManaging ? 'orange' : 'grey'}
    />
  );
};

export default React.memo(AccountDropdownItem);
